import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ImagePreviewProvider } from './components/ImagePreview';
import HomePage from './pages/HomePage';
import FaqPage from './pages/FaqPage';
import CustomerPortal from './pages/CustomerPortal';
import ProductDetail from './pages/ProductDetail';
import MyWins from './pages/MyWins';
import MyProfile from './pages/MyProfile';
import PurchaseGems from './pages/PurchaseGems';
import StoreLogin from './pages/StoreLogin';
import StoreForgotPassword from './pages/StoreForgotPassword';
import CustomerForgotPassword from './pages/CustomerForgotPassword';
import StoreRegister from './pages/StoreRegister';
import StoreDashboard from './pages/StoreDashboard';
import StoreStats from './pages/StoreStats';
import StoreSettings from './pages/StoreSettings';
import StoreRoom from './pages/StoreRoom';
import RoomJoin from './pages/RoomJoin';
import CustomerRoom from './pages/CustomerRoom';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminNewStore from './pages/AdminNewStore';

function App() {
  return (
    <BrowserRouter>
      <ImagePreviewProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/auctions"element={<CustomerPortal />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/my-wins" element={<MyWins />} />
          <Route path="/my-profile" element={<MyProfile />} />
          <Route path="/gem-store" element={<PurchaseGems />} />
          <Route path="/store/login" element={<StoreLogin />} />
          <Route path="/store/forgot-password" element={<StoreForgotPassword />} />
          <Route path="/forgot-password" element={<CustomerForgotPassword />} />
          <Route path="/store/register" element={<StoreRegister />} />
          <Route path="/store/dashboard" element={<StoreDashboard />} />
          <Route path="/store/stats" element={<StoreStats />} />
          <Route path="/store/settings" element={<StoreSettings />} />
          <Route path="/store/rooms/:id" element={<StoreRoom />} />
          <Route path="/room/join" element={<RoomJoin />} />
          <Route path="/room/:id" element={<CustomerRoom />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/stores/new" element={<AdminNewStore />} />
        </Routes>
      </ImagePreviewProvider>
    </BrowserRouter>
  );
}

export default App;
